// Snackbar
export const SNACKBAR_DURATION_SUCCESS = 2500;
export const SNACKBAR_DURATION_ERROR = 5000;

// Dialogs
export const DIALOG_WIDTH_SM = '420px';

// Timers
export const AUTOSAVE_DEBOUNCE_MS = 3000;
export const SETTINGS_RELOAD_DELAY_MS = 1000;

// Layout
export const LAYOUT_HEADER_HEIGHT_PX = 64;
export const LAYOUT_MOBILE_BREAKPOINT_PX = 900;

// Select width calculation
export const SELECT_MIN_WIDTH_PX = 160;
export const SELECT_FONT_SIZE_PX = 16;
export const SELECT_PADDING_PX = 90;

// Pagination
export const UNGROUPED_CHARGERS_PAGE_SIZE = 10;
export const USERS_PAGE_SIZE = 10;

// API
export const TRANSACTION_ID = '1';

// Validation
export const SERIAL_NUMBER_LENGTH = 15;
export const BLUETOOTH_PASSKEY_LENGTH = 6;
export const GROUP_NAME_MAX_LENGTH = 100;
